<template>
  <div id="myVideo" class="m-popup vedio-popup" @click.stop.prevent="" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.2);z-index: 9001;">
    <table style="  table-layout: fixed;width: 100%;height: 100%;">
      <tr>
        <td>
          <div class="wrapper" style="width: 722px;  border-radius: 0;position: relative;margin: 0 auto;background: #fff;box-shadow: 0 2px 10px rgba(0,0,0,0.2);">
            <div class="header f-ff0" style="border: none;line-height: 60px;height:60px;padding: 0 24px;border-bottom: 1px solid #e8e8e8;">
              <span id="videoTitle" style="font-size: 18px;font-weight: bolder;color: #333;"></span>
              <a href="javascript:void(0);" style="float:right;display: inline-block;width: 18px;height: 18px;background: url('https://image.izhaowo.com/www2/images/x.png');margin-top: 20px;" title="关闭"  @click="closeVideo"></a>
            </div>
            <div class="content f-ff0" style="min-height: 100px;">
              <!-- 弹窗内容区域 -->
              <div style="width: 722px; height: 455px;background: #eee;" id="youkuplayer"></div>
              <!-- /弹窗内容区域 -->
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default{
    name:'video',
    props:['videoKey'],
    data:function () {
      return{
        medikey:this.videoKey
      }
    },
    created:function () {

    },
    methods:{
      showVideo:function(vid){
        let myVid = vid;
        let player =  new YKU.Player('youkuplayer',{
          styleid: '0',
          width: '722',
          height:'455',
          client_id: '130c178aa3592893',
          vid: vid,
          newPlayer:true
        });

      },
      closeVideo:function () {
        this.bus.$emit("closevideo");
      }
    },
    mounted:function () {
      this.showVideo(this.medikey);
    }
  }

</script>



// WEBPACK FOOTER //
// openVideo.vue?c823fd60